module.exports = __webpack_public_path__ + "fonts/trust_sans_bold-webfont.4eed6c0e.woff2";